module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section about-page-hero"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content background-1-20-before"
  }, [_c('div', {
    staticClass: "hero-title background-1-50-before background-1-100-after"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content color-1-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-1-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-description background-1-10-before"
  }, [(!_vm.pageEditMode) ? _c('span', {
    staticClass: "content color-2-77",
    domProps: {
      "innerHTML": _vm._f("nl2br")(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-button",
    class: _vm.pageEditMode ? 'edit-mode' : ''
  }, [(_vm.pageEditMode) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element form-element--half"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Button text")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.button.text),
      expression: "content.heroSection.button.text"
    }],
    staticClass: "form-control form-control__input",
    attrs: {
      "type": "text",
      "placeholder": "Button text"
    },
    domProps: {
      "value": (_vm.content.heroSection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection.button, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element form-element--half"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Button link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.button.link),
      expression: "content.heroSection.button.link"
    }],
    staticClass: "form-control form-control__input",
    attrs: {
      "type": "text",
      "placeholder": "Button link"
    },
    domProps: {
      "value": (_vm.content.heroSection.button.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection.button, "link", $event.target.value)
      }
    }
  })])])] : [_c('a', {
    attrs: {
      "href": _vm.content.heroSection.button.link
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.button.text))])], _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image hero-image__about background-1-10-after background-2-4-before"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.howItWorksSection.hideSection || _vm.content.howItWorksSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.howItWorksSection.hideSection || content.howItWorksSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper how-it-works-section about-page-section landing-page-wrapper__gray",
    attrs: {
      "role": "region",
      "aria-labelledby": "howItWorksTitle"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.hideSection),
      expression: "content.howItWorksSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showhowItWorksSection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.howItWorksSection.hideSection) ? _vm._i(_vm.content.howItWorksSection.hideSection, null) > -1 : (_vm.content.howItWorksSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.howItWorksSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.howItWorksSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.howItWorksSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.howItWorksSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showhowItWorksSection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-container"
  }, [(!_vm.pageEditMode && _vm.content.howItWorksSection.title !== '') ? _c('h2', {
    staticClass: "section-title",
    attrs: {
      "id": "howItWorksTitle"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.howItWorksSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.title),
      expression: "content.howItWorksSection.title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.howItWorksSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.howItWorksSection, "title", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && _vm.content.howItWorksSection.description !== '') ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._f("nl2br")(_vm.content.howItWorksSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.description),
      expression: "content.howItWorksSection.description"
    }],
    staticClass: "section-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.howItWorksSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.howItWorksSection, "description", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "list flex-section"
  }, _vm._l((_vm.content.howItWorksSection.sections), function(item, index) {
    return _c('div', {
      staticClass: "list-item"
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.howItWorksSection.sections, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "list-item-icon"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-title"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-description"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._f("nl2br")(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "content-slider"
  }, [(_vm.slidesReady) ? _c('slick', {
    ref: "howItWorksSlick",
    staticClass: "slider",
    attrs: {
      "options": _vm.howItWorksOptionsContent
    }
  }, _vm._l((_vm.content.howItWorksSection.sections), function(item) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-icon"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-title"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-description"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._f("nl2br")(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])
  }), 0) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('how-it-works')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.subscribeSection.hideSection || _vm.content.subscribeSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.subscribeSection.hideSection || content.subscribeSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper subscribe-section about-page landing-page-wrapper__gray"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.hideSection),
      expression: "content.subscribeSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showSubscribe"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.subscribeSection.hideSection) ? _vm._i(_vm.content.subscribeSection.hideSection, null) > -1 : (_vm.content.subscribeSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.subscribeSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.subscribeSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.subscribeSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.subscribeSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showSubscribe"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section"
  }, [(!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subscribeSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.title),
      expression: "content.subscribeSection.title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.subscribeSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.subscribeSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.subscribeSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._f("nl2br")(_vm.content.subscribeSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.description),
      expression: "content.subscribeSection.description"
    }],
    staticClass: "section-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.subscribeSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.subscribeSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.subscribeSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [_c('form', {
    staticClass: "tcc-form",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.subscribeMe()
      }
    }
  }, [(!_vm.pageEditMode) ? _c('h3', {
    staticClass: "section-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subscribeSection.formTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.formTitle),
      expression: "content.subscribeSection.formTitle"
    }],
    staticClass: "section-subtitle",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Form title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.subscribeSection.formTitle)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.subscribeSection, "formTitle", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    staticClass: "tcc-form-element tcc-form-element__label",
    attrs: {
      "for": "tcc-form-firstname"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.firstname),
      expression: "subscribeForm.firstname"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.subscribeForm.firstname !== '' || _vm.subscribeForm.firstnameFocus,
      'not-empty': _vm.subscribeForm.firstname !== '' || _vm.subscribeForm.firstnameFocus,
      'has-error': this.errors.has('First name')
    }],
    attrs: {
      "id": "tcc-form-firstname",
      "type": "text",
      "name": "First name",
      "data-vv-name": "First name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.subscribeForm.firstname)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.firstnameFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.firstnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    staticClass: "tcc-form-element tcc-form-element__label",
    attrs: {
      "for": "tcc-form-lastname"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.lastname),
      expression: "subscribeForm.lastname"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.subscribeForm.lastname !== '' || _vm.subscribeForm.lastnameFocus,
      'not-empty': _vm.subscribeForm.lastname !== '' || _vm.subscribeForm.lastnameFocus,
      'has-error': this.errors.has('Last name')
    }],
    attrs: {
      "id": "tcc-form-lastname",
      "type": "text",
      "name": "Last name",
      "data-vv-name": "Last name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.subscribeForm.lastname)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.lastnameFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.lastnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    staticClass: "tcc-form-element tcc-form-element__label",
    attrs: {
      "for": "tcc-form-email"
    }
  }, [_vm._v("Email address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.email),
      expression: "subscribeForm.email"
    }],
    staticClass: "tcc-form-element tcc-form-element__input light",
    class: [{
      'border-1-50': _vm.subscribeForm.email !== '' || _vm.subscribeForm.emailFocus,
      'not-empty': _vm.subscribeForm.email !== '' || _vm.subscribeForm.emailFocus,
      'has-error': this.errors.has('Email address')
    }],
    attrs: {
      "id": "tcc-form-email",
      "type": "email",
      "name": "Email address",
      "data-vv-name": "Email address",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.subscribeForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email address')))]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-message",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? _c('div', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n                Submitting\n              ")]) : [(_vm.formStatus.shown) ? [(_vm.formStatus.title !== '') ? _c('h2', [(_vm.formStatus.success) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-envelope",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-envelope",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM384 320c0 17.67-14.33 32-32 32H160c-17.67 0-32-14.33-32-32V238l122.1 48.82C251.1 287.6 253.1 288 256 288s4.031-.375 5.938-1.141L384 238V320zM384 203.6l-128 51.2L128 203.6V192c0-17.67 14.33-32 32-32h192c17.67 0 32 14.33 32 32V203.6z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })])], _vm._v("\n                    " + _vm._s(_vm.formStatus.title) + "\n                  ")], 2) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v("\n                    " + _vm._s(_vm.formStatus.body) + "\n                  ")]) : _vm._e()] : (this.errors.items && this.errors.items.length) ? [_c('h2', [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n                    Some fields are missing.\n                  ")]), _vm._v(" "), _c('p', [_vm._v("Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.")])] : _vm._e()]], 2)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.clientSection.hideSection || _vm.content.clientSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.clientSection.hideSection || content.clientSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper clients-section about-page"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.hideSection),
      expression: "content.clientSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showClient"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.clientSection.hideSection) ? _vm._i(_vm.content.clientSection.hideSection, null) > -1 : (_vm.content.clientSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.clientSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.clientSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showClient"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-title"
  }, [(!_vm.pageEditMode && _vm.content.clientSection.title && _vm.content.clientSection.title !== '') ? _c('h2', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.title),
      expression: "content.clientSection.title"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "title", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section-description"
  }, [(!_vm.pageEditMode && _vm.content.clientSection.description && _vm.content.clientSection.description !== '') ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._f("nl2br")(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [_c('div', {
    staticClass: "clients-slider"
  }, _vm._l((_vm.content.clientSection.logos), function(item) {
    return _c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(item.image),
        "alt": item.altImage
      }
    })])
  }), 0), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-slider-change",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.switchSliderModal()
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.testimonialsSection.hideSection || _vm.content.testimonialsSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.testimonialsSection.hideSection || content.testimonialsSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper testimonials-section landing-page-wrapper__gray",
    attrs: {
      "id": "our-clients",
      "role": "region",
      "aria-labelledby": "testimonialsTitle"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.testimonialsSection.hideSection),
      expression: "content.testimonialsSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showTestimonialsSection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.testimonialsSection.hideSection) ? _vm._i(_vm.content.testimonialsSection.hideSection, null) > -1 : (_vm.content.testimonialsSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.testimonialsSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.testimonialsSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.testimonialsSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.testimonialsSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showTestimonialsSection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-container"
  }, [(!_vm.pageEditMode) ? _c('h2', {
    staticClass: "section-title center",
    attrs: {
      "id": "testimonialsTitle"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.testimonialsSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.testimonialsSection.title),
      expression: "content.testimonialsSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.testimonialsSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.testimonialsSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.testimonialsSection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_vm._l((_vm.content.testimonialsSection.testimonials), function(item, index) {
    return (_vm.pageEditMode) ? _c('div', {
      key: index,
      staticClass: "list-item edit-mode"
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.testimonialsSection.testimonials, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "list-item-content"
    }, [_c('div', {
      staticClass: "list-item-text"
    }, [(_vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Text",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-image"
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          item.image = null
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [(_vm.isGM()) ? _c('label', {
      staticClass: "list-item-image-upload",
      attrs: {
        "for": 'testimonial-image-upload-' + index
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isGM()) ? _c('input', {
      attrs: {
        "type": "file",
        "id": 'testimonial-image-upload-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-meta"
    }, [_c('div', {
      staticClass: "list-item-meta-name"
    }, [(_vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Name",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-meta-company"
    }, [(_vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.company),
        expression: "item.company"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Company",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.company)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "company", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.company))]) : _vm._e()])])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.pageEditMode && _vm.slidesReady) ? _c('slick', {
    ref: "testimonialsSlick",
    staticClass: "slider",
    attrs: {
      "options": _vm.testimonialsOptionsContent
    }
  }, _vm._l((_vm.content.testimonialsSection.testimonials), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-content"
    }, [_c('div', {
      staticClass: "list-item-text"
    }, [_c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._f("nl2br")(item.text)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "list-item-image"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "list-item-meta"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" | "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.company)
      }
    })])])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('testimonials')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.contactCTA.hideSection || _vm.content.contactCTA.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.contactCTA.hideSection || content.contactCTA.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper contact-cta-section",
    attrs: {
      "role": "region",
      "aria-labelledby": "contactCTATitle"
    }
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactCTA.hideSection),
      expression: "content.contactCTA.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showContactCTASection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.contactCTA.hideSection) ? _vm._i(_vm.content.contactCTA.hideSection, null) > -1 : (_vm.content.contactCTA.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.contactCTA.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.contactCTA, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.contactCTA, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.contactCTA, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showContactCTASection'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta"
  }, [_c('div', {
    staticClass: "contact-cta--content"
  }, [_c('div', {
    staticClass: "contact-cta--content__title"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.contactCTA.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactCTA.title),
      expression: "content.contactCTA.title"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactCTA.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactCTA, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.contactCTA.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta--content__text"
  }, [(!_vm.pageEditMode) ? _c('p', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.contactCTA.text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.contactCTA.text),
      expression: "content.contactCTA.text"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.contactCTA.text)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.contactCTA, "text", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.contactCTA.text))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta--actions",
    class: _vm.pageEditMode ? 'edit-mode' : ''
  }, [_vm._l((_vm.content.contactCTA.buttons), function(button) {
    return [(_vm.pageEditMode) ? [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "form-element form-element--half"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "page-versions"
      }
    }, [_vm._v("Button text")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (button.text),
        expression: "button.text"
      }],
      staticClass: "form-control form-control__input",
      attrs: {
        "type": "text",
        "placeholder": "Button text"
      },
      domProps: {
        "value": (button.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(button, "text", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-element form-element--half"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "page-versions"
      }
    }, [_vm._v("Button link")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (button.link),
        expression: "button.link"
      }],
      staticClass: "form-control form-control__input",
      attrs: {
        "type": "text",
        "placeholder": "Button link"
      },
      domProps: {
        "value": (button.link)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(button, "link", $event.target.value)
        }
      }
    })])])] : [_c('a', {
      attrs: {
        "href": button.link
      }
    }, [_vm._v(_vm._s(button.text))])]]
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('contact-cta-button')
      }
    }
  }, [_vm._v("+ Add button")]) : _vm._e()], 2)])])]), _vm._v(" "), (_vm.activePopup && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "iconPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Upload icons for: " + _vm._s(_vm.activePopup.title))]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.image)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'image')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImage),
      expression: "activePopup.altImage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.imageHigh)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-high-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-high-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'imageHigh')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImageHigh),
      expression: "activePopup.altImageHigh"
    }],
    attrs: {
      "type": "text",
      "placeholder": "High contrast image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImageHigh)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImageHigh", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.sliderModalShown && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "sliderPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change slider items")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [_vm._l((_vm.content.clientSection.logos), function(item, index) {
    return _c('div', {
      staticClass: "logo-item"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImageHigh),
        expression: "item.altImageHigh"
      }],
      attrs: {
        "type": "text",
        "placeholder": "High contrast image alt"
      },
      domProps: {
        "value": (item.altImageHigh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImageHigh", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "logo-url"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "placeholder": "url"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.clientSection.logos, index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('logos')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tcc-form-actions"
  }, [_c('button', {
    staticClass: "tcc-form-action background-1-20 background-1-60-hover",
    attrs: {
      "name": "subscribe",
      "type": "submit"
    }
  }, [_vm._v("Subscribe")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d3f3fed","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/About.vue
// module id = 1033
// module chunks = 0